(function () {
  // Only run on product pages
  if (!window.location.pathname.match(/products\//)) return;

  // Helper: replace visible text nodes
  function replaceIn(el) {
    // Only replace in elements within the purchase options/widget area
    // Adjust selectors if your theme is customized:
    const container = el.closest?.(
      '.purchase-options, .product-form, form[action*="/cart/add"]'
    ) || el;

    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null);
    let node;
    while ((node = walker.nextNode())) {
      // Replace “Deliver every …” with “Renews every …” (case-insensitive)
      const before = node.nodeValue;
      const after = before.replace(/Deliver every/gi, 'Renews every');
      if (after !== before) node.nodeValue = after;
    }
  }

  // Initial run after DOM ready (some widgets render immediately)
  function initialPass() {
    document
      .querySelectorAll('.purchase-options, .selling-plan, .shopify-section, form[action*="/cart/add"]')
      .forEach(replaceIn);
  }

  // MutationObserver to catch late/dynamic renders from the Subscriptions widget
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const n of m.addedNodes) {
        if (n.nodeType === 1) {
          if (
            n.matches?.('.purchase-options, .selling-plan, .product-form, form[action*="/cart/add"]') ||
            n.querySelector?.('.purchase-options, .selling-plan, .product-form, form[action*="/cart/add"]')
          ) {
            replaceIn(n);
          }
        }
      }
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    // Run once after a short delay to give the widget time to mount
    setTimeout(initialPass, 500);

    // Observe the product info area for dynamic changes
    const target =
      document.querySelector('.product, .product__info-wrapper, main, body') || document.body;

    observer.observe(target, {
      childList: true,
      subtree: true
    });

    // Safety pass a bit later in case of very slow loads
    setTimeout(initialPass, 1500);
  });
})();